import React from 'react';

import styled from 'styled-components';

const FakeBar = styled.div`
  content: '';
  position: absolute;
  top: 105px;
  left: 50%;
  width: calc(100vw + 50%);
  height: 19rem;
  background-color: #72169b;
  z-index: 0;
  transform: translate(-50%, -50%);
`;

const FakeHorizontalSubHeader: React.FC = () => {
  return (
    <FakeBar />
  );
}

export default FakeHorizontalSubHeader;